var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"to":_vm.url}},[_c('b-button',{staticClass:"glow-button d-flex align-items-center",attrs:{"variant":"primary","size":"lg"}},[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('ArrowNextCircle')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }